import { Suspense, lazy } from 'react'
import { Routes, Route } from 'react-router-dom'
import { ROUTES } from './config/constants'
import Layout from './components/layout/Layout'
import { ErrorBoundary } from './components/common'
import Loader from './components/ui/Loader'

// Lazy load pages for better performance
const HomePage = lazy(() => import('./components/pages/HomePage'))
const AboutPage = lazy(() => import('./components/pages/AboutPage'))
const ClassesPage = lazy(() => import('./components/pages/ClassesPage'))
const GalleryPage = lazy(() => import('./components/pages/GalleryPage'))
const TestimonialsPage = lazy(() => import('./components/pages/TestimonialsPage'))
const TrainersPage = lazy(() => import('./components/pages/TrainersPage'))
const ContactPage = lazy(() => import('./components/pages/ContactPage'))
const FormSuccessPage = lazy(() => import('./components/pages/FormSuccessPage'))

/**
 * Main Application Component
 * Implements code-splitting with React.lazy for optimal performance
 */
function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path={ROUTES.home} element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path={ROUTES.about.slice(1)} element={<AboutPage />} />
            <Route path={ROUTES.classes.slice(1)} element={<ClassesPage />} />
            <Route path={ROUTES.gallery.slice(1)} element={<GalleryPage />} />
            <Route path={ROUTES.testimonials.slice(1)} element={<TestimonialsPage />} />
            <Route path={ROUTES.trainers.slice(1)} element={<TrainersPage />} />
            <Route path={ROUTES.contact.slice(1)} element={<ContactPage />} />
            <Route path={ROUTES.formSuccess.slice(1)} element={<FormSuccessPage />} />
          </Route>
        </Routes>
      </Suspense>
    </ErrorBoundary>
  )
}

export default App
